"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPackagingSetComplete = void 0;
const common_1 = require("../../common");
class SetPackagingSetComplete extends common_1.UpdateAction {
}
exports.SetPackagingSetComplete = SetPackagingSetComplete;
//# sourceMappingURL=set-packaging-set-complete.action.js.map